import Image from 'next/image';
import {BANNER_EVENT_IMAGE} from '../../../config/constants/img';

type Props = Record<string, unknown>;

export const EventListPageBanner: React.FC<Props> = () => {
  return (
    <a
      href="https://event.gaishishukatsu.com/"
      target="_blank"
      rel="noreferrer noopener"
    >
      <Image
        src={BANNER_EVENT_IMAGE}
        alt="開催イベント一覧"
        width={300}
        height={80}
      />
    </a>
  );
};
